module.exports = __webpack_public_path__ + "static/media/isuniversity.org.db36cb85.png";